import {FC} from "react";
import {Table} from "react-bootstrap";
import {useAppSelector} from "../../../../redux/hooks/hook";
import _ from "lodash";
import clsx from "clsx";
import {stLabel} from "../../../../constants/game";

const HistoryTable: FC = () => {
    const statistic = useAppSelector(state => state.gameState.game.statistic);

    return <div className="w-100 max-w-100 bg-white">
        <Table className="border-bottom his-table w-100 ">
            <tbody>
            {statistic.range.map((e, i) => {
                return <tr key={i}>
                    {e.map((p, j) => {
                        return <td key={j} className="text-danger border p-0 fw">
                            <span
                                className={clsx(`text-white fw-bolder d-flex rounded-circle fs-1 justify-content-center align-items-center tb-aspec result-dice-${_.toLower(p)}`,
                                    {"text-transparent": p === ""}
                                )}>
                                {stLabel[p]}
                            </span>
                        </td>
                    })}
                </tr>
            })}
            </tbody>
        </Table>
    </div>
}

export {HistoryTable}